import React from 'react'
import { connect } from 'react-redux'
import MetaTags from 'react-meta-tags'
import {
  getTopic,
  makeSelectTopic,
  //selectTopic,
  addActiveExplanation,
} from '../../../redux/modules/topic'
import { entityExists } from '../../../redux/modules/entities'
import { selectUserInfo } from '../../../redux/modules/session'
import VisibleTopicHeader from './VisibleTopicHeader'
import { toJS } from '../../../util/ToJS'
import { withNav } from '../../../core/components/navbar/index'
import { Redirect } from 'react-router'
import TopicBody from './TopicBody'
import qs from 'query-string'
import LoadingSpinner from '../../../core/components/loading-spinner/LoadingSpinner'
// import LoadingSwitch from '../../../core/components/loading-switch/LoadingSwitch'
import ScrollToTopButton from '../../../core/components/scroll-to-top-button/ScrollToTopButton'
import { Transition } from 'react-transition-group'
import rAF from '../../../util/requestAnimationFrame'
import Box from '../../../core/components/box/Box'

const duplicate_pages = {
  10654: '/t/calculate-standard-deviation-4644',
  10656: '/t/calculating-range-4646',
  10630: '/t/casework-and-the-law-of-total-probability-9868',
  10644: '/t/choose-a-sample-population-4657',
  10678: '/t/comparing-two-data-sets-using-box-and-whisker-plots-5324',
  10631: '/t/complement-of-an-event-4667',
  10637: '/t/compound-event-4676',
  10627: '/t/conditional-probability-4678',
  10662: '/t/cumulative-frequency-table-4637',
  2876: '/t/dealing-with-radicals-absolute-values-etc-2883',
  10729: '/t/dependent-vs-independent-variables-in-the-regression-model-5402',
  10635: '/t/find-odds-in-favor-or-against-4668',
  10648: '/t/finding-percentile-rank-4651',
  10628: '/t/inclusion-exclusion-principle-4677',
  2326: '/t/inverses-of-power-functions-are-power-functions-4802',
  10683: '/t/mode-when-there-is-more-than-mode-5319',
  10622: '/t/multiplication-counting-principle-4661',
  10695: '/t/number-of-permutations-fundamental-counting-principle-5377',
  10641: '/t/quantitative-vs-qualitative-data-4654',
  10647: '/t/quartiles-median-minimums-and-maximum-4649',
  10643: '/t/sampling-random-systematic-and-stratified-4656',
  10629: '/t/selecting-with-replacement-4674',
  10636: '/t/selecting-without-replacement-4675',
  10657: '/t/standard-deviation-4647',
  10658: '/t/statistically-significant-4650',
  10649: '/t/stem-and-leaf-plot-4652',
  10646: '/t/survey-question-biased-4659',
  3825: '/t/the-laws-of-thermodynamics-from-a-statistical-mechanics-perspective-3826',
  10634: '/t/two-dependent-events-4673',
  10633: '/t/two-independent-events-4672',
  10663: '/t/two-way-frequency-table-4638',
  10710: '/t/two-way-tables-to-analyze-conditional-probability-5408',
  10642: '/t/univariate-vs-bivariate-data-4655',
  10638: '/t/what-are-permutations-and-factorials-4662',
  10653: '/t/when-to-use-mean-median-mode-4643',
  10655: '/t/word-problem-4645',
}

const animationHelper = (callback) => {
  rAF(() => {
    rAF(() => {
      callback()
    })
  })
}

class VisibleTopic extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      animate: true
    }
  }
  componentDidMount() {
    const { match, location, getTopic } = this.props;
    const topicIdOrSlug = match.params.topicIdOrSlug;

    const topicId = topicIdOrSlug
      .toString()
      .split('-')
      .pop()
    getTopic(topicId)
  }

  componentWillReceiveProps(nextProps) {
    const { match, getTopic, topic } = this.props
    const topicIdOrSlug = match.params.topicIdOrSlug.toString()
      .split('-')
      .pop()
    const newTopicIdOrSlug = nextProps.match.params.topicIdOrSlug.toString()
      .split('-')
      .pop()

    if (topicIdOrSlug !== newTopicIdOrSlug) {
      const topicId = newTopicIdOrSlug
        .toString()
        .split('-')
        .pop()
      getTopic(topicId)
    }
    if (topic.isLeaf && !nextProps.topic.isLeaf) {
      this.setState({animate: true})
    }
  }
  componentWillUpdate(nextProps) {

    const { didGetTopic, isFetching, topic, history } = nextProps
    if (
      !isFetching &&
      didGetTopic &&
      history.location.pathname === `/t/${topic.id}`
    ) {
      history.replace({
        pathname: topic.slug,
        search: history.location.search
      })
    }
  }
  componentDidUpdate(prevProps, prevState) {
    const {topic } = prevProps
    if (topic.id !== this.props.topic.id && topic.isLeaf && this.props.topic.isLeaf) {
      this.setState({animate: false})
      animationHelper(() => this.setState({animate:true}))
    }
  }
  render() {
    const { didGetTopic, topic, isFetching, isHidden, className, location, match, errorMessage } = this.props
    if (isHidden) {
      return <Redirect to={{pathname: '/404', state : {problem: 'Invalid topic id'}}} />
    }
    const matchTopicId = match.params.topicIdOrSlug
      .toString()
      .split('-')
      .pop()
    const topicObjId = topic.id ? topic.id.toString() : topic.id
    if (!isFetching && !didGetTopic && errorMessage !== null) {
      return <Redirect to={{pathname: '/404', state : {problem: errorMessage}}} />
    } else if (isFetching && !didGetTopic || matchTopicId !== topicObjId) {
      // @TODO: topic object and match param get out of sync somehow.
      // This is a bandaid solution to prevent it from totally failing.
      return <LoadingSpinner className={className ? className : ''} />
    }
    const searchQuery = qs.parse(location.search)
    if (didGetTopic) {
      const duration = 250

      let defaultStyle = {
        transition: `transform ${duration}ms ease-out, opacity ${duration*1.5}ms ease-out`,
        transform: 'translateX(10%)',
        opacity: '0.3',
      }
      let transitionStyles = {
        entering: { transform: 'translateX(10%)', opacity: '0' },
        entered:  { transform: 'translateX(0)', opacity: '1' },
        exiting: { transform: 'translateX(0%)', opacity: '0', transition: 'none' },
        exited: { transform: 'translateX(0%)', opacity: '0' }
      }
      let defaultStyleLeft = {
        transition: `transform ${duration}ms ease-out, opacity ${duration*1.5}ms ease-out`,
        transform: 'translateX(-10%)',
        opacity: '0'
      }
      let transitionStylesLeft = {
        entering: { transform: 'translateX(-10%)', opacity: '0' },
        entered:  { transform: 'translateX(0)', opacity: '1' },
        exiting: { transform: 'translateX(0%)', opacity: '0', transition: 'none'},
        exited: { transform: 'translateX(0%)', opacity: '0' }
      }
      if (location.state && location.state.leafDirection) {
        if (location.state.leafDirection === 'left') {
          defaultStyle = defaultStyleLeft
          transitionStyles = transitionStylesLeft
        }
      }
      return (
        <div className={className ? className : ''}>
          <MetaTags>
            <title>{`${topic.title} - Expii`}</title>
            <link rel="canonical" href={`https://www.expii.com${duplicate_pages[topic.id] ? duplicate_pages[topic.id] : topic.slug}`} />
            <meta name="keywords"
              content="interactive science lessons, interactive math lessons, common core standards, virtual tutor, learn, videos, lectures, practice, exercises, skills" />
            <meta property="og:title" content={`${topic.title} - Expii`} />
            <meta property="og:url" content={`https://www.expii.com${topic.slug}`} />
            {topic.description && <meta name="description" content={topic.description} />}
            {topic.description && <meta property="og:description" content={topic.description} />}
          </MetaTags>
          <VisibleTopicHeader practiceRemoved={searchQuery.type === 'problem'} />
          <Box overflow='hidden'>
            <Transition in={this.state.animate} timeout={duration}>
              {(state) => (
                <div style={{
                  ...defaultStyle,
                  ...transitionStyles[state]
                }}>
                  <TopicBody isFetching={isFetching} searchQuery={searchQuery} />
                </div>
              )}
            </Transition>
          </Box>
          <ScrollToTopButton className='topic-scroll-to-top' />
        </div>
      )
    }
    return <div>No Topic</div>
  }
}

const makeMapStateToProps = () => {
  const selectTopic = makeSelectTopic()
  const mapStateToProps = state => {
    const userInfo = selectUserInfo(state)
    const isModerator = (userInfo.role === 'mod' || userInfo.role === 'admin')
    if (entityExists(state, 'topic', state.getIn(['topic', 'topic']))) {
      const topic = selectTopic(state)
      return {
        isFetching: state.getIn(['topic', 'isFetching']),
        isHidden: state.getIn(['topic', 'isHidden']) && !isModerator,
        topic: topic,
        didGetTopic: !topic.isEmpty(),
        activeExplanationId: state.getIn(['topic', 'activeExplanationId'])
      }
    } else {
      return {
        isFetching: state.getIn(['topic', 'isFetching']),
        isHidden: state.getIn(['topic', 'isHidden']) && !isModerator,
        topic: {},
        didGetTopic: false,
        activeExplanationId: state.getIn(['topic', 'activeExplanationId']),
        errorMessage: state.getIn(['topic', 'errorMessage']),
      }
    }
  }
  return mapStateToProps
}
/*const mapStateToProps = state => {
  const user = domain.get('user')
  const userRole = user.get('role')
  const isModerator = (userRole === 'mod' || userRole === 'admin')
  const domain = state.get('topic')
  if (entityExists(state, 'topic', domain.get('topic'))) {
    const topic = selectTopic(state)
    return {
      isFetching: domain.get('isFetching'),
      isHidden: domain.get('isHidden') && !isModerator,
      topic: topic,
      didGetTopic: !topic.isEmpty(),
      activeExplanationId: domain.get('activeExplanationId'),
    }
  } else {
    return {
      isFetching: domain.get('isFetching'),
      isHidden: domain.get('isHidden') && !isModerator,
      topic: {},
      didGetTopic: false,
      activeExplanationId: domain.get('activeExplanationId'),
      errorMessage: state.getIn(['topic', 'errorMessage']),
    }
  }
}*/

const mapDispatchToProps = dispatch => {
  return {
    getTopic: id => {
      dispatch(getTopic(id))
    },
    addActiveExplanation: explanationId => {
      dispatch(addActiveExplanation(explanationId))
    }
  }
}

export default connect(makeMapStateToProps, mapDispatchToProps)(
  toJS(withNav(VisibleTopic, true))
)



// WEBPACK FOOTER //
// ./src/domains/topic/containers/VisibleTopic.js